module.exports = __webpack_public_path__ + "static/media/LoadingScreenDesktop.80b9025c.svg";